/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destination_Description_DashboardInputs */



/**
* | output |
* | --- |
* | "Only dataset spaces you can write to are listed: a dashboard runs its queries inside one." |
*
* @param {Agent_Builder_Destination_Description_DashboardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destination_description_dashboard = /** @type {((inputs?: Agent_Builder_Destination_Description_DashboardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destination_Description_DashboardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es werden nur Datensatz-Bereiche angezeigt, in die Sie schreiben dürfen: Ein Dashboard führt seine Abfragen darin aus.")
	return /** @type {LocalizedString} */ ("Only dataset spaces you can write to are listed: a dashboard runs its queries inside one.")
});